import { Subject } from "rxjs";

export class LocalStore extends Subject<{ type: "set" | "get" | "delete", key: string, value?: any }> {

    constructor () {
        super();
    }

    set (key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
        this.next({ type: "set", key, value });
    }

    get (key: string) {
        const value = localStorage.getItem(key);
        if (value === null) return null;

        this.next({ type: "get", key });
        return JSON.parse(value);
    }

    delete (key: string) {
        localStorage.removeItem(key);

        this.next({ type: "delete", key });
    }
}